<script setup lang="ts">
import HeaderComponent from '@/components/HeaderComponent.vue'
import SideChanger from '@/components/SideChanger.vue'
import PersonDescribeSection from '@/components/PersonDescribeSection.vue'
import { Routes, RoutesName } from '@/enums/Routes'
import { useOurModelStore } from '@/store/ourModel.store'
import { useCommonElementsStore } from '@/store/commonElements.store'
import ContactComponent from '@/components/ContactComponent.vue'
import { ApplicationMode } from '@/enums/ApplicationMode'
import OurModelSection from '@/components/ourModel/OurModelSection.vue'

useHead({
  title: 'Our delivery model',
  meta: [
    {
      name: 'description',
      content:
        'We believe that business, software and IT needs must be delivered in a new ' +
        'and more future-oriented way. Needs must be realized faster and the solutions ' +
        'must create more value to maintain competitive advantage in a digital world ' +
        'that moves at a fast pace.',
    },
  ],
})

const commonStore = useCommonElementsStore()
const hero = useOurModelStore().getHeader
const sections = useOurModelStore().getSections
const contact = useOurModelStore().getContact
const sideChanger = useOurModelStore().getSideChanger

const prev = {
  title: sideChanger?.leftText ?? '',
  section: RoutesName.HOME,
  route: Routes.HOME,
}

const next = {
  title: sideChanger?.rightText ?? '',
  section: RoutesName.SERVICES,
  route: Routes.SERVICES,
}
</script>

<template>
  <div>
    <HeaderComponent
      v-if="hero"
      :title="hero.title"
      :describe="hero.copy"
      :background="hero.background"
      :mode="ApplicationMode.Header"
    >
      <div
        class="rounded-[8px] lg:rounded-[16px] drop-shadow-lg overflow-hidden"
      >
        <ElCard class="p-4 lg:p-8" body-style="padding: 0;">
          <div class="flex flex-col">
            <OurModelSection
              v-for="(elem, index) in sections"
              :key="elem.id"
              :title="elem.title"
              :copy="elem.copy"
              :long="elem.additionalCopy"
              :img="elem.image"
              :index="index"
            />
            <ContactComponent
              v-if="contact"
              :title="contact.title"
              :copy="contact.copy"
              class="mt-16"
            />
          </div>
        </ElCard>
      </div>
    </HeaderComponent>
    <div>
      <SideChanger v-if="sideChanger" :prev="prev" :next="next">
        <PersonDescribeSection
          v-if="commonStore.getBusinessCard"
          :business-card="commonStore.getBusinessCard"
        />
      </SideChanger>
    </div>
  </div>
</template>

<style lang="scss" scoped>
:deep(.el-input__wrapper),
:deep(.el-textarea__inner) {
  background: #fff;
}

:deep(.el-input__wrapper) {
  margin: 0;
}
</style>
